// extracted by mini-css-extract-plugin
export default {"iconTextElement":"IconTextElement_iconTextElement__pYSCO","icon":"IconTextElement_icon__jJFZn","text":"IconTextElement_text__51Z6l"};